// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__2m-PG","imageUploader":"EGiftCard_imageUploader__1zHBE"};